<app-list-module-table
  variant="surface"
  [columns]="columns"
  [rows]="rows"
  [loading]="loading"
  [emptyMessage]="emptyMessage"
>
  <ng-template listCellDef="date" let-row="row">
    <div class="text-sm font-medium text-gray-900 dark:text-white">{{ entryDateDisplay(row.sort_at) }}</div>
    <div class="text-xs text-gray-400">{{ entryTimeDisplay(row.sort_at) }}</div>
  </ng-template>

  <ng-template listCellDef="type" let-row="row">
    @if (isSession(row)) {
    <span
      class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
      [class]="sessionTypeClass(row.session)"
    >
      {{ sessionType(row.session) }}
    </span>
    } @else if (isLogin(row)) {
    <span
      class="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 dark:bg-amber-950/50 dark:text-amber-200"
    >
      Portal Login
    </span>
    } @else if (isEvent(row)) {
    <span
      class="inline-flex items-center rounded-full bg-sky-100 px-2 py-0.5 text-xs font-medium text-sky-800 dark:bg-sky-950/50 dark:text-sky-200"
    >
      System Event
    </span>
    }
  </ng-template>

  <ng-template listCellDef="agent" let-row="row">
    @if (isSession(row)) {
    <span [title]="agentName(row.session)">{{ agentName(row.session) }}</span>
    } @else if (isLogin(row)) {
    <span [title]="loginUserName(row.login)">{{ loginUserName(row.login) }}</span>
    } @else if (isEvent(row)) {
    <span [title]="eventActor(row.event)">{{ eventActor(row.event) }}</span>
    }
  </ng-template>

  <ng-template listCellDef="customer" let-row="row">
    @if (isSession(row)) {
    <span [title]="row.session.customer_name ?? ''">{{ row.session.customer_name || '—' }}</span>
    } @else if (isLogin(row)) {
    <span [title]="loginUserEmail(row.login)">{{ loginUserEmail(row.login) }}</span>
    } @else if (isEvent(row)) {
    <span [title]="eventResource(row.event)">{{ eventResource(row.event) }}</span>
    }
  </ng-template>

  <ng-template listCellDef="event" let-row="row">
    @if (isSession(row)) {
    {{ eventLabel(row.session) }}
    } @else if (isLogin(row)) {
    Sign-in
    } @else if (isEvent(row)) {
    <span class="font-mono text-xs" [title]="row.event.action">{{ row.event.action }}</span>
    }
  </ng-template>

  <ng-template listCellDef="result" let-row="row">
    @if (isSession(row)) {
      @if (sessionResult(row.session); as result) {
      <span
        class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold"
        [class]="statusClass(row.session)"
      >
        {{ statusLabel(row.session) }}
      </span>
      } @else {
      <span class="text-xs text-gray-400">—</span>
      }
    } @else if (isLogin(row)) {
    <span
      class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold"
      [class]="loginStatusClass(row.login)"
    >
      {{ loginStatusLabel(row.login) }}
    </span>
    } @else if (isEvent(row)) {
    <span
      class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold"
      [class]="eventOutcomeClass(row.event)"
    >
      {{ eventOutcomeLabel(row.event) }}
    </span>
    }
  </ng-template>

  <ng-template listCellDef="score" let-row="row">
    @if (isSession(row)) {
    <span class="font-mono text-sm font-semibold" [class]="scoreClass(row.session)">{{ scoreDisplay(row.session) }}</span>
    } @else {
    <span class="text-xs text-gray-400">—</span>
    }
  </ng-template>

  <ng-template listCellDef="runtime" let-row="row">
    @if (isSession(row)) {
    <span class="font-mono">{{ runtimeDisplay(row.session) }}</span>
    } @else if (isLogin(row)) {
    {{ loginRuntimeDisplay(row.login) }}
    } @else {
    <span class="text-xs text-gray-400">—</span>
    }
  </ng-template>

  <ng-template listCellDef="actions" let-row="row">
    @if ((P.AUDIT_TRAIL_VIEW | hasPermission) && canOpenRowDetail(row)) {
    <div class="inline-flex items-center justify-end gap-1">
      <button
        type="button"
        class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-primary hover:bg-primary/10"
        title="View"
        aria-label="View"
        (click)="openDetail(row)"
      >
        <icon-eye class="h-4 w-4" />
      </button>
    </div>
    }
  </ng-template>
</app-list-module-table>
